import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";

import TrainingAssessmentTestModal from "./TrainingAssessmentTestModal";

import {
  getAllTrainingAssessmentTestList,
  getTrainingAssessmentInfo,
} from "../../services/TrainingAssessment/TrainingAssessmentServices";
import CommonHeading from "../../../../../common/components/Custom Hooks/CommonHeading";
import SearchDropdown from "../../../../../common/components/FormFields/searchDropdown";
import DropdownField from "../../../../../common/components/FormFields/DropdownField";
import CommonButton from "../../../../../common/components/Buttons/CommonButton";
import LoadingSpinner from "../../../../../common/components/loadingspinner/loadingSpinner";
import CommonTransactionPaginationTable from "../../../../../common/components/CommonTable/CommonTransactionPaginationTable";
import ConfirmationModal from "../../../../../common/components/ConfirmationModal";
import { DeleteIcon, EditIcon } from "../../../../../assets/CommonAssets";
import { errorAlert } from "../../../../../common/components/Toasts/CustomToasts";

const userActions = [
  {
    id: 0,
    permission: "Edit",
    isAction: true,
  },
  {
    id: 1,
    permission: "Delete",
    isAction: true,
  },
  {
    id: 2,
    permission: "Create",
    isAction: false,
  },
];

/****************** state variables ********************/

const TrainingAssessmentTest = () => {
  const [TrainingAssessmentTestModalOpen, setTrainingAssessmentTestModalOpen] =
    useState(false);
  const [TrainingAssessmentTestData, setTrainingAssessmentTestData] = useState(
    [],
  );
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [spinner, showSpinner] = React.useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [openBackDrop, setOpenBackdrop] = useState(false);
  const [
    TrainingAssessmentTestNameOptions,
    setTrainingAssessmentTestNameOptions,
  ] = useState([]);
  const [listingObject, setListingObject] = useState({
    searchString: "",
    page: page,
    size: rowsPerPage,
    searchId: null,
    menuId: null,
  });
  const { control, setValue, watch } = useForm();
  const [count, setCount] = useState(0);

  const populateTable = (forPagination = false) => {
    let tempObj = { ...listingObject, page: !forPagination ? 0 : page };

    showSpinner(true);
    getAllTrainingAssessmentTestList(tempObj)
      .then((response) => response.data)
      .then((res) => {
        if (res.statusCode === 200 || res.statusCode === 204) {
          if (forPagination) {
            setTrainingAssessmentTestData((prevData) => [
              ...prevData,
              ...res.result,
            ]);
          } else {
            setTrainingAssessmentTestData(res.result);
          }
          setCount(res.count);
          showSpinner(false);
        }
      })
      .catch((error) => {
        console.log(error);
        showSpinner(false);
      });
  };

  //   const handleDelete = () => {
  //     setOpenBackdrop(true);
  //     if (selectedRow !== null) {
  //       deleteAllTrainingAssessmentTest(selectedRow.Id)
  //         .then((response) => response.data)
  //         .then((res) => {
  //           successAlert(res.message);
  //           populateTable();
  //           setOpenDeleteModal(false);
  //           setOpenBackdrop(false);
  //           setSelectedRow(null);
  //         })
  //         .catch((errors) => {
  //           console.log("err", errors);
  //           setOpenDeleteModal(false);
  //           setOpenBackdrop(false);
  //           setTrainingAssessmentTestModalOpen(false);
  //           setSelectedRow(null);
  //           errorAlert(errors.message);
  //         });
  //     }
  //   };

  useMemo(() => {
    populateTable();
  }, [listingObject.searchId, listingObject.searchString]);

  useEffect(() => {
    if (selectedRow !== null && selectedRow?.id) {
      setOpenBackdrop(true);
      getTrainingAssessmentInfo(selectedRow?.id)
        .then((response) => response.data)
        .then((res) => {
          if (res.statusCode === 200) {
            const finalData = JSON.parse(res.result);
            console.log(finalData, "assessmentInfo");
            setSelectedRow(finalData);
            setOpenBackdrop(false);
          }
        })
        .catch((error) => {
          errorAlert(error.message);
          setOpenBackdrop(false);
        });
    }
  }, [selectedRow]);
  const renderActions = (row, index) => {
    return (
      <div className="flex gap-0 items-center">
        {userActions.map((actions, i) => (
          <>
            {actions.isAction === true ? (
              <>
                <div className="flex gap-2 cursor-pointer ">
                  {actions.permission === "Edit" ? (
                    <button
                      type={"button"}
                      onClick={() => {
                        setTrainingAssessmentTestModalOpen(true);
                        setSelectedRow(row);
                      }}
                    >
                      <EditIcon title={"Edit"} sx={{ color: "gray" }} />
                    </button>
                  ) : null}
                </div>
              </>
            ) : null}
            {actions.isAction === true ? (
              <>
                <div className="flex gap-2 cursor-pointer">
                  {actions.permission === "Delete" ? (
                    <button
                      type={"button"}
                      onClick={() => {
                        setOpenDeleteModal(true);
                        setSelectedRow(row);
                      }}
                    >
                      <DeleteIcon sx={{ color: "#D11A2A" }} />
                    </button>
                  ) : null}
                </div>
              </>
            ) : null}
          </>
        ))}
      </div>
    );
  };
  /****************** renderInput ********************/
  const renderInput = (row, index, header) => {
    return (
      <>
        {header === "Status" && (
          <button
            className={`h-6 w-24 whitespace-nowrap border rounded capitalize px-5 text-center
                     ${
                       row?.Status === true
                         ? "text-customGreen border-customGreen"
                         : "text-customRed border-customRed"
                     }`}
            type="button"
          >
            {row?.Status === true ? "Active" : "InActive"}
          </button>
        )}
      </>
    );
  };

  return (
    <div className="px-2 my-1">
      {CommonHeading("Training Assessment")}
      <div className="flex gap-2 w-full items-center mt-2">
        <div className="flex w-full lg:grid grid-cols-2 gap-2 items-center ">
          <div className="grid w-full grid-cols-3 col-span-2 gap-2">
            <SearchDropdown
              control={control}
              name="SearchableSelect"
              placeholder="Search by Assessment"
              isSearchable={true}
              searchIcon={true}
              dataArray={TrainingAssessmentTestNameOptions}
              handleInputChange={(e) => {
                // const tempCheckChar =
                //   e !== null ? UseCheckConsecutiveCharacters(e) : true;
                // if (e !== "" && tempCheckChar) {
                //   getAllTrainingAssessmentTestName(e)
                //     .then((response) => {
                //       setTrainingAssessmentTestNameOptions(
                //         response.data.result,
                //       );
                //     })
                //     .catch((error) => {
                //       console.log(error);
                //     });
                // } else {
                //   setTrainingAssessmentTestNameOptions([]);
                // }
              }}
              onChange={(e) => {
                setSearchString(e !== "" ? e : null);
              }}
              isClearable={true}
            />
            <DropdownField
              dataArray={[]}
              control={control}
              name="training"
              placeholder="Training"
              // error={errors.training}
              isClearable={true}
              isSearchable={true}
            />
            <div>
              <CommonButton
                className="bg-customBlue text-white"
                searchIcon={true}
                onClick={() =>
                  setListingObject({
                    searchString: searchString,
                    page: page,
                    size: rowsPerPage,
                    searchId: watch("SearchableSelect")
                      ? watch("SearchableSelect").id
                      : null,
                    menuId: null,
                  })
                }
              />
            </div>
          </div>
        </div>
        <div className="grid justify-end xl:col-span-3 w-1/3">
          {userActions &&
            userActions.map((obj) => (
              <>
                {!obj.isAction && obj.permission === "Create" ? (
                  <CommonButton
                    onClick={() => setTrainingAssessmentTestModalOpen(true)}
                    label="+ New"
                    className="modalButton bg-customBlue text-white"
                  />
                ) : null}
              </>
            ))}
        </div>
      </div>
      {spinner ? (
        <div className="grid justify-center items-center pt-12">
          <LoadingSpinner />
        </div>
      ) : null}
      {TrainingAssessmentTestModalOpen && (
        <TrainingAssessmentTestModal
          setTrainingAssessmentTestModalOpen={
            setTrainingAssessmentTestModalOpen
          }
          TrainingAssessmentTestModalOpen={TrainingAssessmentTestModalOpen}
          setTrainingAssessmentTestData={setTrainingAssessmentTestData}
          TrainingAssessmentTestData={TrainingAssessmentTestData}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          setOpenBackdrop={setOpenBackdrop}
          openBackDrop={openBackDrop}
          populateTable={populateTable}
        />
      )}
      <div>
        {TrainingAssessmentTestData?.length > 0 ? (
          <CommonTransactionPaginationTable
            page={page}
            rowsPerPage={rowsPerPage}
            setPage={setPage}
            populateTable={populateTable}
            count={count}
            highlightRow={false}
            dataResult={TrainingAssessmentTestData}
            renderActions={renderActions}
            tableClass="capitalize"
            renderInput={renderInput}
            editableColumns={"Status"}
            removeHeaders={["id", "Assessment Type Id"]}
          />
        ) : (
          <>
            {!spinner && (
              <div className="flex justify-center">
                <h3 className="flex justify-center mt-20 font-bold text-gray-600">
                  No Records Found...
                </h3>
              </div>
            )}
          </>
        )}
      </div>
      <ConfirmationModal
        confirmationOpen={openDeleteModal}
        confirmationHandleClose={() => {
          setOpenDeleteModal(false);
          setSelectedRow(null);
        }}
        confirmationLabel="Confirmation"
        confirmationMsg="Are you sure you want to delete this record?"
        confirmationSubmitFunc={() => {}}
        confirmationButtonMsg="Delete"
      />
    </div>
  );
};

export default TrainingAssessmentTest;
